import script from "./AutoLab.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoLab.vue?vue&type=script&setup=true&lang=js"

import "./AutoLab.vue?vue&type=style&index=0&id=3e03cf67&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e03cf67"]])

export default __exports__